import React, { useContext, useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';
import { useParams, useRouteMatch, Switch, Route } from 'react-router';
import { Article } from '../../../types';
import Admin, { Admincontent, Admincontent2, AdminContext, CreateAdminUrl } from '../../containers/Admin';
import { CardContainerStyle } from '../SectionArticles';
import { Container } from '../Container';
import { OfficeDropdown } from '../../ui/dropdown/OfficeDropDown';
import { DdItem, DropdownMenu, GetSelected } from '../../ui/dropdown/Dropdown';
import { LogOutButton } from './LogOutButton';
import { TopMenu as AdminMenu } from './topMenu';

//GraphQL
import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { getAdminClient } from './AdminApolloClient';
import { CAN_ACCESS } from '../../../../client/__graphql__/queries/admin/userCanAccess';
import { MENU_QUERY } from '../../../../client/__graphql__/queries/admin/getMenuOptions';

//Options
import loadable from '@loadable/component';
const PropertyHighlighted = loadable(() => import('./PropertyHighlighted'));
const Articles = loadable(() => import('./article/ArticleList'));
const Users = loadable(() => import('./user/UserList'));

import {
  ContentHomePage,
  ContentFrontPage,
  ContentBrokerPage,
  ContentContactPage,
  ContentCustomerPage,
  ContentServicePage,
  ContentBuy,
  ContentNews
} from './page_content/ContentPages'
import UserList from './user/UserList';

const client = getAdminClient();

export const AdminPanel = (props: { data: []; history: any }) => {
  const match: any = useRouteMatch();
  const context = useContext(AdminContext);
  const params = useParams<{ kontor: string, option: string }>();
  const [header, setHeader] = useState(null);
  const [office_tag, setOfficeTag] = useState(params.kontor);
  const [canAccess, SetCanAccess] = useState(true);
  const [ddloptions, SetDdlOptions] = useState<DdItem[]>([]);
  const [selected, setSelected] = useState<DdItem>({ value: '', label: '' });

  const { data, loading } = useQuery(CAN_ACCESS,
    {
      variables: { input: { urltag: params?.kontor } },
      fetchPolicy: 'network-only',
      client: client,
    }
  );

  const [getMenu, { data: menuData, loading: menuLoading, error: menuError }] = useLazyQuery(MENU_QUERY, {
    fetchPolicy: 'network-only',
    client: client,
    onCompleted: ((data: any) => {
      const arr: DdItem[] = [];

      if (data?.getAdminMenuOptions?.length > 0) {
        data?.getAdminMenuOptions?.map((e: any) => {
          arr.push({
            label: e.name,
            value: e.value
          });
        });
      }

      SetDdlOptions(arr);
      const opt = GetSelected(arr, (selected.value ? selected.value : params?.option));
      if (opt?.value && opt?.value != '') {
        setSelected(opt);
        MoveToPage(office_tag, opt?.value);
      }
      else if (arr && arr.length > 0) {
        setSelected(arr[0]);
        MoveToPage(office_tag, arr[0]?.value);
      }
      else {
        setSelected({ value: '', label: '' });
        MoveToPage(office_tag, '');
      }
    })
  });


  const UpdateMenuOptions = (urltag: string) => {
    getMenu({
      variables: {
        input: {
          urltag: urltag
        }
      }
    })
  };

  const MoveToPage = (office: any, page: any) => {
    if (office) {
      if (!(match?.params?.kontor == office && match?.params?.option == page)) {
        props.history.push(CreateAdminUrl(office, page));
      }
    }
  }

  useEffect(() => {
    if (office_tag) {
      UpdateMenuOptions(office_tag);
    }
  }, [office_tag]);

  useEffect(() => {
    if (data?.userCanAccess != null) {
      if (data?.userCanAccess != canAccess) {
        SetCanAccess(data?.userCanAccess);
      }
    }
  }, [data]);

  if (!header) {
    if (
      params.kontor &&
      context?.adminState?.loggedIn?.user?.offices &&
      context?.adminState?.loggedIn?.user?.offices.length > 1
    ) {
      var indx = context.adminState.loggedIn.user.offices.findIndex(
        (e: any) => e && e.urltag == params.kontor
      );

      if (indx > -1) {
        setHeader(context.adminState.loggedIn.user.offices[indx].name);
      }
    }
  }

  if (!context.adminState.loggedIn.status) {
    return <div></div>;
  }

  const officeHandleChange = (e: any) => {
    setHeader(e.label);
    setOfficeTag(e.value);
  };

  const optionHandleChange = (e: any) => {
    setSelected(e);
    MoveToPage(office_tag, e.value);
  };

  return (
    <Admincontent>
      <Container>
        {canAccess ?
          <>
            <TopMenu>
              {context?.adminState?.loggedIn?.user?.offices?.length > 1 ?
                <MenuItem>
                  <MenuTitle>Velg avdeling</MenuTitle>
                  <OfficeDropdown onChange={officeHandleChange} />
                </MenuItem> : null}
              <MenuItem>
                <MenuTitle>Valg</MenuTitle>
                <DropdownMenu options={ddloptions} onChange={optionHandleChange} selected={selected} />
              </MenuItem>
              <MenuItem style={{ verticalAlign: 'bottom' }} >
                <LogOutButton />
              </MenuItem>
            </TopMenu>
            <div>
              <H1>{header}</H1>
              <Switch>
                <Route exact path="/admin/:kontor/ukensbolig" component={PropertyHighlighted} />
                <Route exact path="/admin/:kontor/tjenester" component={ContentServicePage} />
                <Route exact path="/admin/:kontor/vaarekunder" component={ContentCustomerPage} />
                <Route exact path="/admin/:kontor/forside" component={ContentFrontPage} />
                <Route exact path="/admin/:kontor/vaaremeglere" component={ContentBrokerPage} />
                <Route exact path="/admin/:kontor/kjopenybygg" component={ContentBuy} />
                <Route exact path="/admin/:kontor/nyheter" component={ContentNews} />
                <Route exact path="/admin/:kontor/kontaktoss" component={ContentContactPage} />
                <Route exact path="/admin/:kontor/artikler/:category?" component={Articles} />
                <Route exact path="/admin/:kontor/home" component={ContentHomePage} />
                <Route exact path="/admin/:kontor/users" component={UserList} />
              </Switch>
            </div> </> :
          <div>
            <H1>Mangler tilgang</H1>
          </div>
        }
      </Container>
    </Admincontent>
  );
};

export default AdminPanel;

const TopMenu = styled.div`
  display: flex;
  justify-content: center;
  vertical-align: middle;
  margin-top: 35px;
`;

const MenuItem = styled.div`
  :not(:last-child) {
    padding-right: 30px;
  }

  button {
    margin-top: 14px;
  }
`;

const MenuTitle = styled.label`
  display: inline-block;
  margin-bottom: 4px;
  width: 100%;
`;

const H1 = styled.h1`
  padding-top: 1em;
  text-align: center;
`;
